const SMS_PHONE_REGEX = /(?:\+?86[-\s]?)?1[3-9]\d[-\s]?\d{4}[-\s]?\d{4}/
const SMS_URL_REGEX = /(https?:\/\/|www\.|[A-Za-z0-9-]+\.(com|cn|net|org|cc|co|io|gov|edu)(?:\/|\b))/i

export function hasRestrictedSmsContent (text = '') {
  return SMS_PHONE_REGEX.test(text) || SMS_URL_REGEX.test(text)
}



// WEBPACK FOOTER //
// ./src/util/smsValidation.js